export const SEARCH_LINK_CLICKED = 'search-link-clicked';
export const PIVOT_TOO_LARGE = 'pivot_too_large';
export const TWO_DIM_TABLE_TOO_LARGE = 'two_dim_table_too_large';
export const TWO_DIM_TABLE_SUCCESSFULLY_RENDERED = 'two_dim_table_successfully_rendered';
export const PIVOT_SUCCESSFULLY_RENDERED = 'pivot_successfully_rendered';